import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LazyLoadModule } from 'src/core-lib/lazy-load/lazy-load.module';
import { SplashOutletComponent } from './splash-outlet.component';
import { SplitSplashesPipe } from './split-splashes.pipe';



@NgModule({
  declarations: [SplashOutletComponent, SplitSplashesPipe],
  imports: [
    CommonModule,
    LazyLoadModule,

  ],
  exports: [SplashOutletComponent]
})
export class SplashModule { }
